module.exports = __webpack_public_path__ + "img/datos_estadisticos.8aba1ab3.png";